import { createMainResourceREST, mergeSummaryBodyField } from '../resource/';
import {
  CRImageBody,
  CRImageBodyAPI,
  CRImageKey,
  CRImageSummary,
  CRImageSummaryAPI,
  ImagesActions,
  ImagesState,
} from './types';

type AnyImage = CRImageKey | CRImageSummary | CRImageBody | undefined;

function sameKeyImage(a: AnyImage, b: AnyImage): boolean {
  return a?.imageId === b?.imageId;
}

export function getEndpointImage(key: AnyImage): string {
  return key?.imageId ? `/images/${key.imageId}/` : '/images/';
}

export function getEndpointImageData(key: CRImageKey): string {
  return `${getEndpointImage(key)}imageData/`;
}

function parseImageSummary(imageSummary: CRImageSummaryAPI): CRImageSummary {
  return imageSummary;
}

function parseImageBody(imageDetail: CRImageBodyAPI): CRImageBody {
  return imageDetail;
}

function mergeImageBody(lastBody: CRImageBody, currentBody: CRImageBody) {
  return currentBody;
}

const imagesStateSelector = (state: any): ImagesState => state.images;

function combineSummaryBodyImage(
  summary?: CRImageSummary,
  body?: CRImageBody,
): CRImageSummary {
  const merge = mergeSummaryBodyField(summary, body);
  return {
    imageId: merge('imageId'),
    imageTypeId: merge('imageTypeId'),
    fileExt: merge('fileExt'),
    imageName: merge('imageName'),
    displayFullSize: merge('displayFullSize'),
    imageSrc: (body?.imageSrc ?? summary?.imageSrc)!,
    imageSize: summary?.imageSize ?? 0,
  };
}

const { actions, reducer, watches } = createMainResourceREST(
  'images',
  getEndpointImage,
  imagesStateSelector,
  sameKeyImage,
  parseImageBody,
  parseImageSummary,
  mergeImageBody,
  combineSummaryBodyImage,
  // formatImageBody,
  // validateImages,
);

const imagesActions: ImagesActions = actions;
export {
  imagesActions,
  reducer as imagesReducer,
  watches as imagesWatches,
  imagesStateSelector,
};

export * from './types';
